import { Link } from "react-router-dom";
import { Gem } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";
import { COMMUNITY_ENABLED } from "@/config/featureFlags";
import { NavPricingBadge } from "./NavPricingBadge";

interface NavLinksProps {
  isActive: (path: string) => boolean;
  t: {
    nav: {
      pricing: string;
      explore: string;
      gallery: string;
    };
  };
}

export function NavLinks({ isActive, t }: NavLinksProps) {
  const { user } = useAuth();

  return (
    <>
      <Link
        to="/pricing"
        className={cn(
          "relative flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors rounded-xl",
          isActive("/pricing")
            ? "text-foreground bg-secondary/50"
            : "text-muted-foreground hover:text-foreground hover:bg-secondary/30",
        )}
      >
        <Gem className="w-3.5 h-3.5 text-brand" />
        {t.nav.pricing}
        <NavPricingBadge />
      </Link>

      {COMMUNITY_ENABLED && (
        <Link
          to="/dashboard"
          className={cn(
            "px-4 py-2 text-sm font-medium transition-colors rounded-xl",
            isActive("/dashboard")
              ? "text-foreground bg-secondary/50"
              : "text-muted-foreground hover:text-foreground hover:bg-secondary/30",
          )}
        >
          {t.nav.explore}
        </Link>
      )}

      {/* Only show gallery link when user is logged in */}
      {user && (
        <Link
          to="/gallery"
          className={cn(
            "px-4 py-2 text-sm font-medium transition-colors rounded-xl",
            isActive("/gallery")
              ? "text-foreground bg-secondary/50"
              : "text-muted-foreground hover:text-foreground hover:bg-secondary/30",
          )}
        >
          {t.nav.gallery}
        </Link>
      )}
    </>
  );
}
